import React from 'react';
import './button.css';
var Button = function (_a) {
    var text = _a.text, type = _a.type, onClick = _a.onClick, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    return (<button disabled={disabled} className={disabled ? 'button-main button-main--disabled' : 'button-main'} type={type} onClick={onClick}>
      {text}
    </button>);
};
export default Button;
